import React, { useEffect } from "react"

import { USER_ROUTES } from "@constants"
import { loadIrisProfile } from "@signals/irisProfile"
import PageWrapper from "Pages/@PageWrapper"
import { clearAccountSignals, loadIdentity } from "../Settings/@signals"
import UserSettingsIrisTab from "../Settings/IrisTab"


/**
 * User Settings › Iris (CU-869fmherf D1-D2): the Iris profile on its own page, the old Settings tab's
 * content as is. It loads what Settings' `getAllData` loaded for the tab — the identity "Who you are"
 * mirrors and the profile (a no-op when the widget already has it) — and clears the identity on leaving,
 * as Settings does, so the next user (or a master's slave) never sees the previous one's.
 */
export default function UserIrisPage() {
	useEffect(() => {
		loadIdentity()
		loadIrisProfile()
		return clearAccountSignals
	}, [])

	return <PageWrapper
		head={`DS Rentacar | ${USER_ROUTES.TITLE}`}
		title={USER_ROUTES.TITLE}
		subtitle={USER_ROUTES.IRIS_SUBTITLE}
	>
		<UserSettingsIrisTab/>
	</PageWrapper>
}
